export default "__VITE_ASSET__CiMLJHzW__"